import { ReactComponent as QuestionMarkCircleIcon } from '../../../assets/svg/question-mark-circle.svg';
import { routes } from '../../../routes';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from 'components/atoms/Card/Card';
import classes from 'classnames';
import React, { useState } from 'react';
import styles from './TinkToolbar.module.scss';

export const TinkToolbar = () => {
  const { t } = useTranslation('tinkToolbar');
  const navigate = useNavigate();

  const [showHelpCardDetail, setShowHelpCardDetail] = useState<boolean>(false);

  const onHelpCardClick = () => setShowHelpCardDetail(true);

  const onCloseDetail = () => setShowHelpCardDetail(false);

  const onBankNACardClick = () => {
    navigate(routes.firstLoan_tink_bank_na);
  };

  const onCredentialsCardClick = () => {
    navigate(routes.firstLoan_tink_bank_issue);
  };

  const InitialHelpCard = (
    <Card
      className={styles['help-card']}
      data-test="tinkToolbar-helpCard"
      onClick={onHelpCardClick}
    >
      <QuestionMarkCircleIcon
        className={styles.icon}
        data-test="tinkToolbar-helpCard-icon"
      />
      <div>
        <div className={styles.title} data-test="tinkToolbar-helpCard-title">
          {t('helpCard.title')}
        </div>
        <div
          className={styles.content}
          data-test="tinkToolbar-helpCard-content"
        >
          {t('helpCard.content')}
        </div>
      </div>
    </Card>
  );

  const HelpCardDetail = (
    <div
      className={styles['help-card-detail']}
      data-test="tinkToolbar-helpCardDetail"
    >
      <div className={styles.heading}>
        <QuestionMarkCircleIcon
          className={styles.icon}
          data-test="tinkToolbar-helpCardDetail-icon"
        />
        <div
          className={styles.title}
          data-test="tinkToolbar-helpCardDetail-title"
        >
          {t('helpCardDetail.title')}
        </div>
      </div>
      <div
        className={styles.content}
        data-test="tinkToolbar-helpCardDetail-content"
      >
        {t('helpCardDetail.content')}
      </div>
      <div className={styles['card-options']}>
        <Card
          className={styles['card-option']}
          data-test="tinkToolbar-helpCardDetail-subCard-bank"
          onClick={onBankNACardClick}
        >
          {t('helpCardDetail.bankCard')}
        </Card>
        <Card
          className={styles['card-option']}
          data-test="tinkToolbar-helpCardDetail-subCard-credentials"
          onClick={onCredentialsCardClick}
        >
          {t('helpCardDetail.credentialsCard')}
        </Card>
      </div>
      <Card className={styles['card-close']} onClick={onCloseDetail}>
        <span>{t('helpCardDetail.close')}</span>
      </Card>
    </div>
  );

  return (
    <div
      className={classes(
        styles.layout,
        showHelpCardDetail && styles['layout-detail'],
      )}
      data-test="tinkToolbar-layout"
    >
      {!showHelpCardDetail ? InitialHelpCard : HelpCardDetail}
    </div>
  );
};
